<div class="page-title-area">
    <div class="container">
        <div class="page-title-content">
            <h2>Courses</h2>
            <ul>
                <li><a routerLink="/">Home </a></li>
                <li class="active">Courses</li>
            </ul>
        </div>
    </div>

    <!-- <div class="page-shape">
        <div class="shape1"><img src="assets/images/shape/1.png" alt="shape" /></div>
        <div class="shape3"><img src="assets/images/shape/3.png" alt="shape" /></div>
        <div class="shape4"><img src="assets/images/shape/4.png" alt="shape" /></div>
        <div class="shape5"><img src="assets/images/shape/5.png" alt="shape" /></div>
        <div class="shape6"><img src="assets/images/shape/6.png" alt="shape" /></div>
    </div> -->
</div>
<section class="blog-details-area ptb-100">
    <div class="container">
        <div class="row">
            <div class="col-lg-4 col-md-12">
                <aside class="widget-area" id="secondary">

                    <section class="widget widget_categories">
                        <h3 class="widget-title">Our Courses</h3>

                        <div class="post-wrap">
                            <ul>
                                <li><a (click)="loadCourse('data-science')">BSC DATA SCIENCE</a></li>
                                <li><a (click)="loadCourse('computer-science')">BSC COMPUTER SCIENCE</a></li>
                                <li><a (click)="loadCourse('bca')">BACHELOR OF COMPUTER APPLICATIONS</a></li>
                                <!-- <li><a (click)="loadCourse('math')">BSC MATHEMATICS</a></li> -->
                            </ul>


                        </div>
                    </section>


                </aside>
            </div>
            <div class="col-lg-8 col-md-12">
                <div class="blog-details-desc">

                    <!-- <div class="article-content">
                        <h3>Temperature App UX Studies & Development Case</h3>
                        <p>Quuntur magni dolores eos qui ratione voluptatem sequi nesciunt. Neque porro quia non numquam
                            eius modi tempora incidunt ut labore et dolore magnam dolor sit, consectetur qui ratione
                            voluptatem sequi nesciunt magni dolores eos qui ratione voluptatem sequi nesciunt. Neque
                            porro quia non.</p>
                        <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut
                            labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco
                            laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in
                            sed quia non numquam eius modi tempora incidunt ut labore et dolore magnam aliquam quaerat
                            labore et dolore magna aliqua.</p>
                        <blockquote class="flaticon-quote">
                            <p>Lorem, ipsum dolor sit amet consectetur adipisicing elit. Repellendus aliquid praesentium
                                eveniet illum asperiores, quidem, ipsum voluptatum numquam ducimus nisi exercitationem
                                dolorum facilis Repellendus aliquid praesentium eveniet illum asperiores.</p>
                        </blockquote>
                    </div> -->

                    <div class="article-content" style="margin-top: 0px ;" *ngIf="courseContent">

                        <h3 style="margin-top: 0px;">{{ courseContent.title }}</h3>
                        <p style="font-size: 17px;" [innerHTML]="courseContent.content"></p>
                    </div>

                </div>
            </div>
        </div>
    </div>
</section>